export interface SortByReportParameter {
   value: ReportSortBy;
}

export enum ReportSortBy {
   'Count' = 'Count',
   'Duration' = 'Duration',
}
